import {
  BUSINESS_TYPE_SUCCESS,
  BUSINESS_TYPE_FAILED,
  RESET_BUSINESS_TYPE,
  LOADING_BUSINESS_TYPE,
  NETWORK_ERROR_BUSINESS_TYPE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_BUSINESS_TYPE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
      };
    case BUSINESS_TYPE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
      };
    case BUSINESS_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
      };
    case NETWORK_ERROR_BUSINESS_TYPE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
      };
    case RESET_BUSINESS_TYPE:
      return (state = initialState);
    default:
      return state;
  }
};
